export default {
  "content": "<path d=\"M16.707 8.707L13.414 12l3.293 3.293-1.414 1.414L12 13.414l-3.293 3.293-1.414-1.414L10.586 12 7.293 8.707l1.414-1.414L12 10.586l3.293-3.293 1.414 1.414z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.929 4.929c3.905-3.905 10.237-3.905 14.142 0 3.906 3.905 3.906 10.237 0 14.142-3.905 3.906-10.237 3.906-14.142 0-3.905-3.905-3.905-10.237 0-14.142zm12.728 1.414A8 8 0 106.343 17.658 8 8 0 0017.657 6.343z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};